<template>
	<div class="indexView">
		<el-container>
			<el-main>
				<HeaderRow selUrl="honor"></HeaderRow>
				<div class="banner" v-if="navList[4]&&navList[4].icon_image">
					<el-image style="width: 100%; height: 300px" fit="cover" :src="navList[4].icon_image"></el-image>
				</div>
				<div class="breadcrumb">
					<div class="backItem" @click="()=>$router.back()"><i class="el-icon-arrow-left">返回</i></div>
					<el-breadcrumb separator="/">
						<el-breadcrumb-item to="/">首页</el-breadcrumb-item>
						<el-breadcrumb-item to="/honor">风采展示</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="honorDiv">
					<div class="honorItem" v-for="(item, index) in honorList" :key="`${index}`">
						<el-image :src="item.image" :preview-src-list="imageList">
						</el-image>
						<p>{{item.create_at}}</p>
					</div>
				</div>
				<FooterRow></FooterRow>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import indexjs from "./index.js";
	import {
		copy
	} from "clipboard";
	import HeaderRow from "@/components/headerRow.vue";
	import FooterRow from "@/components/footerRow.vue";

	export default {
		methods: {
			copy,
		},
		...indexjs,
		components: {
			HeaderRow,
			FooterRow,
		},
		computed: {},

	};
</script>

<style lang="scss" scoped>
	@import "./index.scss";
</style>